import React from 'react';

export const OffIcon = ({ onClick, className }) => {
	return (
		<svg
			tabIndex={0}
			// @ts-ignore
			title={'Push Notification is Off'}
			aria-label={'Push Notification is Off'}
			onClick={onClick}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 110 80"
			fill="none"
			strokeWidth="1"
			strokeLinecap="round"
			strokeLinejoin="round"
			className={className}
			id="fab"
		>
			<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<g id="noun_Bell-Off_1698761" className={'g'} fillRule="nonzero">
					<path
						d="M105,11.65 C104.530117,10.3525336 103.097842,9.68115481 101.8,10.15 L79.05,18.5 C75.6632654,6.55438299 64.0225527,-1.09541716 51.7137297,0.535721467 C39.4049066,2.16686009 30.1584628,12.5845811 30,25 L30,36.55 L6.65,45 C5.75683603,45.1518379 5.01252302,45.7686392 4.69743649,46.6180608 C4.38234996,47.4674824 4.54435905,48.420477 5.12243649,49.1180608 C5.70051394,49.8156446 6.60683603,50.1518379 7.5,50 C7.7809779,50.0516671 8.0690221,50.0516671 8.35,50 L30,41.85 L30,46.85 L20.4,61.1 C19.8790962,61.870518 19.8289928,62.8665126 20.269941,63.6854164 C20.7108892,64.5043202 21.5699875,65.0107447 22.5,65 L45,65 C45,70.5228475 49.4771525,75 55,75 C60.5228475,75 65,70.5228475 65,65 L87.5,65 C88.4300125,65.0107447 89.2891108,64.5043202 89.730059,63.6854164 C90.1710072,62.8665126 90.1209038,61.870518 89.6,61.1 L80,46.75 L80,25 C80,24.5 80,24 80,23.5 L103.35,15 C104.037566,14.809852 104.61115,14.3350303 104.926354,13.69507 C105.241559,13.0551097 105.268356,12.3109751 105,11.65 Z M35,25 C35.0286947,14.9508067 42.5098137,6.48335287 52.4788925,5.21663384 C62.4479713,3.9499148 71.8089967,10.2773249 74.35,20 L35,34.7 L35,25 Z M55,70 C52.2385763,70 50,67.7614237 50,65 L60,65 C60,67.7614237 57.7614237,70 55,70 Z M75.4,48.9 L82.85,60 L27.15,60 L34.6,48.9 C34.8590208,48.4787678 34.9973856,47.9944911 35,47.5 L35,40 L75,25.25 L75,47.5 C75.0026144,47.9944911 75.1409792,48.4787678 75.4,48.9 Z"
						id="Shape"
					></path>
				</g>
			</g>
		</svg>
	);
};

export const OnIcon = ({ onClick, className }) => {
	return (
		<svg
			tabIndex={0}
			// @ts-ignore
			title={'Push Notification is On'}
			aria-label={'Push Notification is On'}
			onClick={onClick}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 100 100"
			fill="none"
			strokeWidth="1"
			strokeLinecap="round"
			strokeLinejoin="round"
			className={className}
			id="fab"
		>
			<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<g id="noun_bell-ringing_1698759-(1)">
					<g id="Group">
						<path
							d="M75,71.75 L75,50 C75,36.1928813 63.8071187,25 50,25 C36.1928813,25 25,36.1928813 25,50 L25,71.75 L15.4,86.1 C14.8790962,86.870518 14.8289928,87.8665126 15.269941,88.6854164 C15.7108892,89.5043202 16.5699875,90.0107447 17.5,90 L40,90 C40,95.5228475 44.4771525,100 50,100 C55.5228475,100 60,95.5228475 60,90 L82.5,90 C83.4300125,90.0107447 84.2891108,89.5043202 84.730059,88.6854164 C85.1710072,87.8665126 85.1209038,86.870518 84.6,86.1 L75,71.75 Z M50,95 C47.2385763,95 45,92.7614237 45,90 L55,90 C55,92.7614237 52.7614237,95 50,95 Z M22.15,85 L29.6,73.9 C29.8590208,73.4787678 29.9973856,72.9944911 30,72.5 L30,50 C30,38.954305 38.954305,30 50,30 C61.045695,30 70,38.954305 70,50 L70,72.5 C70.0026144,72.9944911 70.1409792,73.4787678 70.4,73.9 L77.85,85 L22.15,85 Z"
							id="Shape"
							fill-rule="nonzero"
						></path>
						<path
							d="M30,2.5 C30,1.11928813 28.8807119,0 27.5,0 C12.7039629,0.906627658 0.906627658,12.7039629 4.4408921e-16,27.5 C4.4408921e-16,28.8807119 1.11928813,30 2.5,30 C3.88071187,30 5,28.8807119 5,27.5 C5.88481146,15.4591121 15.4591121,5.88481146 27.5,5 C28.1630412,5 28.798926,4.7366079 29.267767,4.26776695 C29.7366079,3.79892601 30,3.16304122 30,2.5 Z"
							id="Path"
						></path>
						<path
							d="M17.5,30 C18.1008181,23.3612011 23.3612011,18.1008181 30,17.5 C31.3807119,17.5 32.5,16.3807119 32.5,15 C32.5,13.6192881 31.3807119,12.5 30,12.5 C20.5789791,13.0650356 13.0650356,20.5789791 12.5,30 C12.5,31.3807119 13.6192881,32.5 15,32.5 C16.3807119,32.5 17.5,31.3807119 17.5,30 Z"
							id="Path"
						></path>
						<path
							d="M70,12.5 C68.6192881,12.5 67.5,13.6192881 67.5,15 C67.5,16.3807119 68.6192881,17.5 70,17.5 C76.6387989,18.1008181 81.8991819,23.3612011 82.5,30 C82.5,31.3807119 83.6192881,32.5 85,32.5 C86.3807119,32.5 87.5,31.3807119 87.5,30 C86.9349644,20.5789791 79.4210209,13.0650356 70,12.5 Z"
							id="Path"
						></path>
						<path
							d="M72.5,0 C71.1192881,0 70,1.11928813 70,2.5 C70,3.88071187 71.1192881,5 72.5,5 C84.5408879,5.88481146 94.1151885,15.4591121 95,27.5 C95,28.8807119 96.1192881,30 97.5,30 C98.8807119,30 100,28.8807119 100,27.5 C99.0933723,12.7039629 87.2960371,0.906627658 72.5,0 Z"
							id="Path"
						></path>
					</g>
				</g>
			</g>
		</svg>
	);
};
